import React from 'react';
import {useShopTheLookScrollManager} from './useShopTheLookScrollManager';

export const ScrollShopTheLookIntoView: React.FC<
  React.PropsWithChildren
> = () => {
  const {ScrollToTarget} = useShopTheLookScrollManager();
  return <ScrollToTarget />;
};
